import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { User } from '@sb-shared/models/user';

@Directive({
    selector: 'ng1-profile-linked',
    standalone: false
})
export class ProfileLinkedUpgrade extends UpgradeComponent {
  @Input() selectedPerson: User;
  @Input() isOrganisationAdmin: boolean;
  @Input() isPopup: boolean;
  @Input() organisationTypeId: number;
  constructor(elementRef: ElementRef, injector: Injector) {
    super('ng1ProfileLinked', elementRef, injector);
  }
}
